import { render } from "./ShareView.vue?vue&type=template&id=dff578b0"
import script from "./ShareView.vue?vue&type=script&lang=js"
export * from "./ShareView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__